enum PeriodType {
  Monthly = 0,
  Annually,
}

export default PeriodType;
